// src/skeletons/ModalPetDetailSkeleton.js
import React, { useRef } from 'react';
import './ModalPetDetailSkeleton.css';

/**
 * ModalPetDetailSkeleton
 * Skeleton placeholder para ModalPetDetail, con debugging de estilos.
 */
export default function ModalPetDetailSkeleton() {
  const ref = useRef(null);

  return (
    <div
      ref={ref}
      className="modalCard modal-skeleton"
      onClick={e => e.stopPropagation()}
    >


      {/* Carrusel placeholder */}
      <div className="skeleton-carousel skeleton-wave" />

      {/* Datos básicos */}
      <div className="skeleton-info">
        <div className="skeleton-line small skeleton-wave" />
        <div className="skeleton-line medium skeleton-wave" />
        <div className="skeleton-line long skeleton-wave" />
      </div>


      {/* Profesional + acciones */}
      <div className="skeleton-prof-row">
        <div className="skeleton-avatar skeleton-wave" />
        <div className="skeleton-line short skeleton-wave" />
        <div className="skeleton-button-circle skeleton-wave" />
        <div className="skeleton-button-circle skeleton-wave" />
      </div>

      {/* Historia texto */}
      <div className="skeleton-history">
        <div className="skeleton-line long skeleton-wave" />
        <div className="skeleton-line medium skeleton-wave" />
        <div className="skeleton-line short skeleton-wave" />
      </div>
    </div>
  );
}
